export function data() {
  return {
    headersDocumentos: [
      { text: 'Descrição', value: 'description' },
      { text: 'Data', value: 'uploaded_on' },
      { text: 'Origem', value: 'from' },
      { text: '', value: 'actions' },
    ],

    documentosList: [],
    documentos: [],
    files: [],

    // Necessário para evitar erros ao adicionar novos documentos
    documento_id: 0,
  }
}
